module.exports = __webpack_public_path__ + "img/Check.045e7654.svg";